
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShoppingBag } from 'lucide-react';

interface NoRentalTariffCardProps {
  currentTariff: string | null;
  onSelectTariff: () => void;
}

export function NoRentalTariffCard({ currentTariff, onSelectTariff }: NoRentalTariffCardProps) {
  return (
    <Card className="w-full bg-card shadow-md overflow-hidden">
      <CardContent className="p-0">
        <div className="p-6">
          <div className="flex flex-col space-y-4">
            <div className="flex items-center justify-center rounded-full bg-primary/10 w-12 h-12 mb-2">
              <ShoppingBag className="h-6 w-6 text-primary" />
            </div>
            
            <div>
              <h3 className="text-lg font-medium">Выбор тарифа</h3>
              <p className="text-sm text-muted-foreground mt-1">
                {currentTariff && currentTariff !== 'Не выбран' && currentTariff !== 'Не указан'
                  ? `Текущий тариф: ${currentTariff}`
                  : 'У вас пока не выбран тариф аренды'}
              </p>
            </div>
            
            <Button 
              data-tariff-button
              className="w-full mt-4" 
              onClick={onSelectTariff}
            >
              {currentTariff && currentTariff !== 'Не выбран' && currentTariff !== 'Не указан'
                ? 'Изменить тариф'
                : 'Выбрать тариф'}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
